import {
	GET_DASHBOARD,
	RESET_DASHBOARD,
	SET_LOADING,
	SHOW_HIDE_CUSTOMER_GROUP_LOCATION,
	SHOW_HIDE_CUSTOMER_MOSAIC_LOCATION,
	SHOW_HIDE_EMPLOYEE_GROUP_LOCATION,
	SHOW_HIDE_EMPLOYEE_MOSAIC_LOCATION,
	UPDATE_CUSTOMER_COLOR,
	UPDATE_EMPLOYEE_COLOR,
	UPDATE_PROPOSED_LOCATIONS_ORDER,
} from "./locationTypes";

const initialState = {
	location: "",
	dashboard: "",
	id: "",
	loading: false,
};

const locationReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_DASHBOARD:
			return {
				...state,
				location: action.payload,
				id: action.id,
				employeeTitleCounts: action.employeeTitleCounts,
				customerTitleCounts: action.customerTitleCounts,
				loading: false,
			};
		case SHOW_HIDE_EMPLOYEE_GROUP_LOCATION:
			return {
				...state,
				employeeTitleCounts: [...action.payload],
				loading: false,
			};
		case SHOW_HIDE_CUSTOMER_GROUP_LOCATION:
			return {
				...state,
				customerTitleCounts: [...action.payload],
				loading: false,
			};
		case SHOW_HIDE_EMPLOYEE_MOSAIC_LOCATION:
			return {
				...state,
				hiddenEmployeeMosaics: [...action.payload],
				loading: false,
			};
		case SHOW_HIDE_CUSTOMER_MOSAIC_LOCATION:
			return {
				...state,
				hiddenCustomerMosaics: [...action.payload],
				loading: false,
			};

		case UPDATE_EMPLOYEE_COLOR:
			return {
				...state,
				employeeTitleCounts: state.employeeTitleCounts.map((employee) => {
					if (employee.jobTitle !== action.payload.jobTitle) return employee;
					return {
						...employee,
						color: action.payload.newColor,
						baseColor: { color: action.payload.newColor, shift: 0 },
					};
				}),
			};

		case UPDATE_CUSTOMER_COLOR:
			return {
				...state,
				customerTitleCounts: state.customerTitleCounts.map((customer) => {
					if (customer.groupTitle !== action.payload.groupTitle) return customer;
					return {
						...customer,
						color: action.payload.newColor,
						baseColor: { color: action.payload.newColor, shift: 0 },
					};
				}),
			};

		case UPDATE_PROPOSED_LOCATIONS_ORDER: {
			if (!state.location || !state.location.proposedLocations) {
				return state;
			}

			const newOrderById = action.payload;

			return {
				...state,
				location: {
					...state.location,
					proposedLocations: state.location.proposedLocations.map((location) => {
						if (location._id in newOrderById) {
							return { ...location, order: newOrderById[location._id] };
						}
						return location;
					}),
				},
			};
		}

		case SET_LOADING:
			return {
				...state,
				loading: true,
				id: action.id,
			};
		case RESET_DASHBOARD:
			return {
				...state,
				location: "",
				id: "",
				loading: false,
			};

		case "CLEAR_LOCATION":
			return {
				...state,
				location: {},
			};
		default:
			return state;
	}
};

export default locationReducer;
